import { getMultidietPopup } from '@/features/multidiet-picker/api/get-cms-popup';
import { MultidietPopupType } from '@/features/multidiet-picker/types/multidiet-popup.type';
import { StrapiMetaType } from '@/types/strapi.type';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

type MultidietPopupResponseType = {
  data: {
    attributes: MultidietPopupType;
  } | null;
  meta: StrapiMetaType['meta'] | null;
  error?: Error;
};

type UseMultidietSetupParams = {
  params?: RequestInit;
  options?: Omit<
    UseQueryOptions<
      MultidietPopupResponseType,
      unknown,
      MultidietPopupResponseType,
      string[]
    >,
    'queryFn' | 'queryKey'
  >;
};

export const useMultidietPopup = ({
  params,
  options,
}: UseMultidietSetupParams) => {
  return useQuery({
    queryKey: ['multidiet-popup'],
    queryFn: () => getMultidietPopup({ params }),
    ...options,
  });
};
